<template>
  <div>
    <div class="opo02">
      <span class="opo03">历史记录</span>
    </div>
    <div class="lsj05">
      <div class="lsj06" @click="checks(1)" :class="[type === 1 ? 'lsj08':'']">新刀领用</div>
      <div class="lsj06" @click="checks(2)" :class="[type === 2 ? 'lsj08':'']">旧刀回收</div>
      <div class="lsj06" @click="checks(3)" :class="[type === 3 ? 'lsj08':'']">废刀修磨</div>
      <div class="lsj06 lsj07" @click="checks(4)" :class="[type === 4 ? 'lsj08':'']">未归还明细</div>
    </div>
    <div class="opo01">
      <div class="djt30" v-if="type == 4">
        <div class="djt31">
          <input v-model="searchs1" type="text" placeholder="请输入姓名或者订单编号" placeholder-class="djt32" class="djt33">
          <img @click="seas1" src="@/assets/images/sea01.png" alt="" class="djt34">
        </div>
      </div>
      <div class="djt30" v-else>
        <div class="djt31">
          <input v-model="searchs" type="text" placeholder="请输入姓名或者订单编号" placeholder-class="djt32" class="djt33">
          <img @click="seas" src="@/assets/images/sea01.png" alt="" class="djt34">
        </div>
      </div>
      <div class="djt30" v-if="user.companytype == 1 && type == 1">
          <div class="djt31-1">
            <img v-if="ishows == 1" src="@/assets/imgs/40.png" @click="check1(2)" class="yujin2" alt="">
            <img v-if="ishows == 2" src="@/assets/imgs/41.png" @click="check1(1)" class="yujin3" alt="">
            <div>新刀领用未归还明细</div>
          </div>
      </div>
      <div style="width: 50%;display: flex;justify-content: flex-end">
        <div class="lsj01" v-if="type === 1 || type === 2 || type === 3">
          <el-date-picker
            v-model="days"
            type="daterange"
            value-format="yyyy-MM-dd"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions">
          </el-date-picker>
        </div>
        <div v-if="type === 1 || type === 2 || type === 3" class="lsj02" @click="xdTime()">确定</div>
        <div v-if="user.companytype != '1' && type != 4" class="lsj02 lsj03" title="导出Excel" @click="toExcel">
          <img src="@/assets/imgs/08.png" alt="" class="lsj04">
          <span>导出表格</span>
        </div>
        <div v-if="type == 4" class="lsj02 lsj03" title="导出Excel" @click="toExcels">
          <img src="@/assets/imgs/08.png" alt="" class="lsj04">
          <span>导出未归还表格</span>
        </div>
      </div>
    </div>
    <div v-if="type == 1 && user.companytype == '1'" class="sche16s" @click="exports(1)">
        <img src="../../assets/imgs/08.png">
        <span>导出领取明细表</span>
    </div>
    <div v-if="type == 2 && user.companytype == '1'" class="sche16s" @click="exports(2)">
        <img src="../../assets/imgs/08.png">
        <span>导出归还明细表</span>
    </div>
    <div class="djt05" v-if="type == 4">
      <div class="djt06">
        <div class="djt06-1">用户名称</div>
        <div class="djt06-1">用户编码</div>
        <div class="djt06-1">未归还刀具总数量</div>
        <div class="djt06-1">状态</div>
        <div class="djt06-1">操作</div>
      </div>
      <el-skeleton animated :loading="loading" :count="6">
        <template slot="template">
          <el-skeleton-item variant="p" style="width: 100%;height: 80px;" />
        </template>
        <template>
          <div class="djt09" v-for="(item,index) in lists" :key="'lls' + index">
            <div class="djt09-1">{{item.name}}</div>
            <div class="djt09-1">{{item.code}}</div>
            <div class="djt09-1">{{item.notreturnnum}}</div>
            <div class="djt09-1">{{item.state}}</div>
            <div class="djt09-1-1">
              <div class="lsj02-1" title="未还详情" @click="weiHuan(item)">
                <img src="@/assets/imgs/19.png" alt="" class="lsj04">
                <span>未还详情</span>
              </div>
              <div class="lsj02-1" title="设置预警数" @click="yuJing(item)">
                <img src="@/assets/imgs/20.png" alt="" class="lsj04">
                <span>设置预警数</span>
              </div>
            </div>
          </div>
        </template>
      </el-skeleton>
      <div class="djt09" style="border-bottom: none;margin-top: 5px;">
        <el-pagination
          @current-change="toPage1"
          background
          :page-size="10"
          :pagerCount="5"
          :total="total"
          layout="prev, pager, next"
          class="djt29"
        >
        </el-pagination>
      </div>
    </div>
    <div class="djt05" v-else>
      <div class="djt06">
        <div class="djt26os">姓名</div>
        <div class="djt26os" v-if="type == 1">三方单号</div>
        <div class="djt26os">工业云账号</div>
        <div class="djt26os">订单编号</div>
        <div class="djt26os" v-if="type == 1">领取方式</div>
        <div class="djt26os" v-if="type == 1">领取时间</div>
        <div class="djt26os" v-if="type == 2 || type == 3">归还方式</div>
        <div class="djt26os" v-if="type == 2 || type == 3">归还时间</div>
        <div class="djt26os">状态</div>
        <div class="djt26os">操作</div>
      </div>
      <el-skeleton animated :loading="loading" :count="6">
        <template slot="template">
          <el-skeleton-item variant="p" style="width: 100%;height: 80px;" />
        </template>
        <template>
          <div class="djt09" v-for="(item,index) in data.dataList" :key="'lis'+index">
            <div class="djt2712s" :title="item.name">{{item.name}}</div>
            <div class="djt2712s" v-if="type == 1">{{item.pushmsg}}</div>
            <div class="djt2712s" :title="item.mobile">{{item.mobile}}</div>
            <div class="djt2712s" :title="item.code">{{item.code}}</div>
<!--            <div class="djt2712" :title="item.details[0].name">{{item.details[0].name}}</div>-->
            <div class="djt2712s" v-if="item.paytypeid == 1" title="支付宝">支付宝</div>
            <div class="djt2712s" v-else-if="item.paytypeid == 2" title="微信">微信</div>
            <div class="djt2712s" v-else title="刷卡">刷卡</div>
            <div class="djt2712s" :title="item.ctime">{{item.ctime}}</div>
            <div class="djt2712s" style="color: #2176FA" v-if="item.state == 1 && type == 1">正常</div>
            <div class="djt2712s" style="color: #FFC400" v-if="item.state == 2 && type == 1">出货异常</div>
            <div class="djt2712s" style="color: red" v-if="item.state == 3 && type == 1">待出货</div>
            <div class="djt2712s" style="color: red" v-if="item.state == 4 && type == 1">订单已取消</div>
            <div class="djt2712s" style="color: #2176FA" v-if="item.state == 1 && (type == 2 || type == 3)">已确认</div>
            <div class="djt2712s" style="color: red" v-if="item.state == 3 && (type == 2 || type == 3)">待确认</div>
            <div class="djt282s">
              <img title="查看详情" v-if="ishows == 2" @click="xiangqs1(item)" src="@/assets/images/xiangq01.png" class="djy16" alt="">
              <img title="查看详情" v-else @click="xiangqs(item)" src="@/assets/images/xiangq01.png" class="djy16" alt="">
            </div>
          </div>
        </template>
      </el-skeleton>
      <div class="djt09" style="border-bottom: none;margin-top: 5px;">
        <!-- <el-pagination
          @current-change="toPage"
          background
          :page-size="8"
          :pagerCount="5"
          :total="totals"
          layout="prev, pager, next"
          class="djt29"
        >
        </el-pagination> -->
        <Page :total="totals" :page-size="10" @on-change="toPage"/>
      </div>
    </div>

    <xc-model :loading="isModel" title="详细信息" :is_buttom="false" @cancel="cancel">
      <div slot="mbody">
        <div class="djt17">
          <div class="lsj09">
            <div class="lsj10">个人信息</div>
            <div class="lsj11">
              <div class="lsj12 lsj13">姓名：{{lsItem.name}}</div>
              <div class="lsj12 lsj13">卡号：{{lsItem.cardno}}</div>
              <div class="lsj12">工业云账号：{{lsItem.mobile}}</div>
            </div>
          </div>
          <div class="lsj09 lsj14">
            <div class="lsj10">商品信息</div>
            <div class="lsj11">
              <div class="lsj12 lsj13">商品名称：{{lsItem.details[0].name}}</div>
              <div class="lsj12 lsj13">商品编码：{{lsItem.details[0].code}}</div>
              <div class="lsj12">规格：{{lsItem.details[0].specs}}</div>
              <div class="lsj12 lsj13">金额：{{lsItem.details[0].totalprice}}</div>
            </div>
          </div>
          <div class="lsj09 lsj14">
            <div class="lsj10">记录信息</div>
            <div class="lsj11">
              <div class="lsj12 lsj13">领取时间：{{lsItem.ctime}}</div>
              <div class="lsj12 lsj13">
                <span v-if="lsItem.paytypeid == 1">领取方式：支付宝</span>
                <span v-if="lsItem.paytypeid == 2">领取方式：微信</span>
                <span v-if="lsItem.paytypeid == 3">领取方式：刷卡</span>
              </div>
              <div class="lsj12">
                <span v-if="lsItem.state == 1">状态：正常</span>
                <span v-if="lsItem.state == 2">状态：出货异常</span>
                <span v-if="lsItem.state == 3">状态：待出货</span>
                <span v-if="lsItem.state == 4">状态：订单已取消</span>
              </div>
            </div>
          </div>
          <div class="djt21">
            <div class="djt22" @click="cancel">确认</div>
            <div class="djt22" style="margin-left: 50px" @click="cancel">取消</div>
          </div>
        </div>
      </div>
    </xc-model>

    <xc-model :loading="returnWarn" title="归还预警提示提示" :is_buttom="false" @cancel="closes">
            <div slot="mbody">
                <div class="sche21-01">
                    <div class="sche22-02">
                        <div class="sche23-03">
                          所有刀具领取大于：<input v-model="limitNums" class="spans1"/>总数量时，账号状态<span :class="[states == '正常'? 'active1' : 'active2']">显示{{states}}</span>
                        </div>
                    </div>
                    <div class="sche25-05">
                        <div class="sche26-06" @click="opens">确认</div>
                        <div class="sche26-06" style="margin-left: 50px" @click="closes">取消</div>
                    </div>
                </div>
            </div>
        </xc-model>
  </div>
</template>

<script>
  var me;
  var user;
  import httpUser from "@/api/user";
  import https from '@/api/schemaSequence';
  import http from '@/api/retrieve';
  import util from '@/util/util';
  export default {
    name: "djgorder",
    data(){
      return {
        ishows:1,
        limitNums:'',
        states:'',
        returnWarn:false,
        lists:[],
        total:0,
        totals:0,
        searchs:'',
        searchs1:'',
        isModel:false,
        loading:true,
        pageSize:10,
        page:1,
        data:[],
        name:'',
        num:'',
        spec:'',
        imageUrl: '',
        days:[],
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '清空',
            onClick(picker) {
              picker.$emit('pick', ['', '']);
            }
          }]
        },
        type:1,
        lsItem:{
          name:'',
          cardno:'',
          mobile:'',
          details:[
            {
              name:'',
              code:'',
              specs:'',
              totalprice:''
            }
          ],
          ctime:'',
          paytypeid:'',
          state:''
        },
        user:'',
        userId:''
      }
    },
    created() {
      me = this;
      user = JSON.parse(sessionStorage.getItem('user'));
    },
    mounted() {
      this.user = JSON.parse(sessionStorage.getItem('user'));
      let data = {
        type:me.type,
        companyid:user.companyId,
        page:1,
        pageSize:me.pageSize,
        starttime:'',
        endtime:'',
      }
      httpUser.getorderlist(data).then(res => {
        me.data = res.data;
        me.totals = res.data.totalNum
        let arr = {
          name:'无',
          code:'无',
          specs:'无',
          totalprice:'无'
        }
        me.data.dataList.forEach(function (item,index) {
          if (item.details.length == 0) {
            item.details.push(arr);
          }
        })
        me.loading = false;
        console.log(res);
      })
    },
    methods:{
      check1(e){
        me.ishows = e
        if(e == 1) {
          let data = {
            type:me.type,
            companyid:user.companyId,
            page:me.page,
            pageSize:me.pageSize,
            starttime:'',
            endtime:''
          }
          if (me.searchs != '') {
            me.$set(data,'keyword',me.searchs);
          }
          if (me.days.length > 0) {
            data['starttime'] = me.days[0];
            data['endtime'] = me.days[1];
          }
          httpUser.getorderlist(data).then(res => {
            me.data = res.data;
            me.totals = res.data.totalNum
            let arr = {
              name:'无',
              code:'无',
              specs:'无',
              totalprice:'无'
            }
            me.data.dataList.forEach(function (item,index) {
              if (item.details.length == 0) {
                item.details.push(arr);
              }
            })
            me.loading = false;
          })
        }else{
          let data = {
            type:4,
            companyid:user.companyId,
            page:me.page,
            pageSize:me.pageSize,
            starttime:'',
            endtime:'',
          }
          if (me.searchs != '') {
            me.$set(data,'keyword',me.searchs);
          }
          if (me.days.length > 0) {
            data['starttime'] = me.days[0];
            data['endtime'] = me.days[1];
          }
          httpUser.getorderlist(data).then(res => {
            me.data = res.data;
            me.totals = res.data.totalNum
            let arr = {
              name:'无',
              code:'无',
              specs:'无',
              totalprice:'无'
            }
            me.data.dataList.forEach(function (item,index) {
              if (item.details.length == 0) {
                item.details.push(arr);
              }
            })
            me.loading = false;
          })
        }
      },
      opens(){
        let data = {
          companyId:user.companyId,
          id:me.userId,
          num:me.limitNums
        }
        http.updateLimitnum(data).then(res=>{
          if(res.code == '0000'){
            me.$message.success('修改成功')
            let data = {
              companyid:user.companyId,
              userid:'',
              keyword:'',
              page:me.page,
              pageSize:me.pageSize,
            };
            http.getnotreturned(data).then(res=>{
              me.lists = res.data.dataList
              me.total = res.data.totalNum
            })
            me.returnWarn = false
          }
        })
      },
      closes(){
        me.returnWarn = false
      },
      weiHuan(item){
        // console.log(item,'item')
        this.$router.push({path:'/notReturndetail',
        query:{ id:item.id,
                notreturnnum:item.notreturnnum,
                state:item.state,
                name:item.name,
                orgname:item.orgname,
                orgname2:item.orgname2,
                code:item.code
              }
        })
      },
      yuJing(item){
        me.limitNums = item.limitnum
        me.states = item.state
        me.userId = item.id
        me.returnWarn = true
      },
      exports(e){
        if(e == 1) {
          me.$Loading.start();
            let data = {
                starttime:me.days[0],
                endtime:me.days[1],
                companyid:user.companyId
            }
            https.exportlymx(data).then(res=>{
                const blob = new Blob([res],{ type: 'application/vnd.ms-excel'});//处理文档流
                const fileName = '领取明细表.csv';
                const elink = document.createElement('a');
                elink.download = fileName;
                elink.style.display = 'none';
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
                me.loading = false;
                me.$Loading.finish();
            })
        }else{
          me.$Loading.start();
            let data = {
                starttime:me.days[0],
                endtime:me.days[1],
                companyid:user.companyId
            }
            https.exportghmx(data).then(res=>{
                const blob = new Blob([res],{ type: 'application/vnd.ms-excel'});//处理文档流
                const fileName = '归还明细表.csv';
                const elink = document.createElement('a');
                elink.download = fileName;
                elink.style.display = 'none';
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
                me.loading = false;
                me.$Loading.finish();
            })
        }
      },
      toExcel(){//导出
        me.$Loading.start();
        let data = {
          type:me.type,
          companyid:user.companyId,
          page:1,
          pageSize:20
        }
        if (me.searchs != '' && me.searchs.indexOf(' ') == -1) {
          me.$set(data,'keyword',me.searchs);
        }
        if (me.days.length != 0) {
          me.$set(data,'starttime',me.days[0]);
          me.$set(data,'endtime',me.days[1]);
        }
        httpUser.exportbydataorderlist(data).then(res => {
          const blob = new Blob([res],{ type: 'application/vnd.ms-excel'});//处理文档流
          const fileName = '刀具柜订单记录.csv';
          const elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
          me.loading = false;
          me.$Loading.finish();
        })
      },
      toExcels(){
        me.$Loading.start();
        let data = {
          companyid:user.companyId
        }
        https.exportwghmx(data).then(res=>{
          const blob = new Blob([res],{ type: 'application/vnd.ms-excel'});//处理文档流
          const fileName = '未归还明细表.csv';
          const elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
          me.loading = false;
          me.$Loading.finish();
        })
      },
      xiangqs(item){//查看详情
        // me.lsItem = item;
        // console.log(item);
        // me.isModel = true;
        me.$router.push({path:'/order/detail',query:{data:JSON.stringify(item),type:me.type}});
      },
      xiangqs1(item){//新刀领取查看详情
        me.$router.push({path:'/wghDetail',query:{id:item.id}});
      },
      xdTime(){//选中时间点击确定
        console.log(me.days)
        me.$Loading.start();
        let data = {
          type:me.type,
          companyid:user.companyId,
          page:1,
          pageSize:me.pageSize,
          starttime:'',
          endtime:'',
        }
        if (me.searchs != '') {
            me.$set(data,'keyword',me.searchs);
          }
        if (me.days.length > 0) {
          data['starttime'] = me.days[0];
          data['endtime'] = me.days[1];
        }
        httpUser.getorderlist(data).then(res => {
          me.data = res.data;
          me.totals = res.data.totalNum
          let arr = {
            name:'无',
            code:'无',
            specs:'无',
            totalprice:'无'
          }
          me.data.dataList.forEach(function (item,index) {
            if (item.details.length == 0) {
              item.details.push(arr);
            }
          })
          me.$Loading.finish();
          console.log(res);
        })
      },
      checks(e){
        // me.page = 1;
        me.type = e;
        if(e == 4){
          me.loading = true;
          let data = {
            companyid:user.companyId,
            userid:'',
            keyword:'',
            page:1,
            pageSize:me.pageSize,
          };
          http.getnotreturned(data).then(res=>{
            me.lists = res.data.dataList
            me.total = res.data.totalNum
            me.loading = false;
          })
        }else{
          if(this.ishows == 2 && e == 1) {
            let data = {
              type:4,
              companyid:user.companyId,
              page:me.page,
              pageSize:me.pageSize,
              starttime:'',
              endtime:'',
            }
            if (me.searchs != '') {
                me.$set(data,'keyword',me.searchs);
              }
            if (me.days.length > 0) {
              data['starttime'] = me.days[0];
              data['endtime'] = me.days[1];
            }
            httpUser.getorderlist(data).then(res => {
              me.data = res.data;
              me.totals = res.data.totalNum
              let arr = {
                name:'无',
                code:'无',
                specs:'无',
                totalprice:'无'
              }
              me.data.dataList.forEach(function (item,index) {
                if (item.details.length == 0) {
                  item.details.push(arr);
                }
              })
              me.loading = false;
            })
          }else{
            me.loading = true;
            let data = {
              type:e,
              companyid:user.companyId,
              page:1,
              pageSize:me.pageSize,
              starttime:'',
              endtime:'',
            }
            if (me.searchs != '') {
              me.$set(data,'keyword',me.searchs);
            }
            if (me.days.length > 0) {
              data['starttime'] = me.days[0];
              data['endtime'] = me.days[1];
            }
            httpUser.getorderlist(data).then(res => {
              me.data = res.data;
              me.totals = res.data.totalNum
              let arr = {
                name:'无',
                code:'无',
                specs:'无',
                totalprice:'无'
              }
              me.data.dataList.forEach(function (item,index) {
                if (item.details.length == 0) {
                  item.details.push(arr);
                }
              })
              me.loading = false;
            })
          }
        }
      },
      seas1(){
        me.loading = true;
          let data = {
            companyid:user.companyId,
            userid:'',
            keyword:me.searchs1,
            page:me.page,
            pageSize:me.pageSize,
          };
          http.getnotreturned(data).then(res=>{
            me.lists = res.data.dataList
            me.tatal = res.data.totalNum
            me.loading = false;
          })
      },
      seas(){
        me.$Loading.start();
        let data = {
          type:me.type,
          companyid:user.companyId,
          page:1,
          pageSize:me.pageSize,
          starttime:'',
          endtime:'',
        }
        if (me.searchs != '') {
            me.$set(data,'keyword',me.searchs);
          }
        if (me.days.length > 0) {
          data['starttime'] = me.days[0];
          data['endtime'] = me.days[1];
        }
        httpUser.getorderlist(data).then(res => {
          me.data = res.data;
          me.totals = res.data.totalNum
          let arr = {
            name:'无',
            code:'无',
            specs:'无',
            totalprice:'无'
          }
          me.data.dataList.forEach(function (item,index) {
            if (item.details.length == 0) {
              item.details.push(arr);
            }
          })
          me.$Loading.finish();
        })
      },
      toPage1(e){
        me.loading = true;
          let data = {
            companyid:user.companyId,
            userid:'',
            keyword:'',
            page:e,
            pageSize:me.pageSize,
          };
          http.getnotreturned(data).then(res=>{
            me.lists = res.data.dataList
            me.tatal = res.data.totalNum
            me.loading = false;
          })
      },
      toPage(e){//分页
        me.loading = true;
        me.page = e;
        if(this.ishows == 2 && me.type == 1) {
          let data = {
            type:4,
            companyid:user.companyId,
            page:e,
            pageSize:me.pageSize,
            starttime:'',
            endtime:'',
          }
          if (me.searchs != '') {
            me.$set(data,'keyword',me.searchs);
          }
          if (me.days.length > 0) {
            data['starttime'] = me.days[0];
            data['endtime'] = me.days[1];
          }
          httpUser.getorderlist(data).then(res => {
            me.data = res.data;
            me.totals = res.data.totalNum
            let arr = {
              name:'无',
              code:'无',
              specs:'无',
              totalprice:'无'
            }
            me.data.dataList.forEach(function (item,index) {
              if (item.details.length == 0) {
                item.details.push(arr);
              }
            })
            me.loading = false;
          })
        }else{
          let data = {
            type:me.type,
            companyid:user.companyId,
            page:e,
            pageSize:me.pageSize,
            starttime:'',
            endtime:'',
          }
          if (me.searchs != '') {
            me.$set(data,'keyword',me.searchs);
          }
          if (me.days.length > 0) {
            data['starttime'] = me.days[0];
            data['endtime'] = me.days[1];
          }
          httpUser.getorderlist(data).then(res => {
            me.data = res.data;
            me.totals = res.data.totalNum
            let arr = {
              name:'无',
              code:'无',
              specs:'无',
              totalprice:'无'
            }
            me.data.dataList.forEach(function (item,index) {
              if (item.details.length == 0) {
                item.details.push(arr);
              }
            })
            me.loading = false;
          })
        }
      },
      cancel(){//添加框点击返回
        me.isModel = false;
      },
    }
  }
</script>

<style scoped>
@import "djgorder.css";
</style>